import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Compliance from "@/pages/Compliance";

export const Route = createFileRoute("/compliance")({
  head: () => buildRouteHead({ pathname: "/compliance" }),
  component: Compliance,
});
